export default "__VITE_ASSET__eicTgRCZ__"